import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { GroupBy } from '@factorialco/f0-react/icons/app'
import { FormInsightsOverviewElementFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  element: FormInsightsOverviewElementFragment
  children: React.ReactNode
}

export function Section({ element, children }: Props) {
  return (
    <Box gap="s32">
      <Box paddingLeft="s16" gap="s8">
        <Box flexDirection="row" alignItems="center" gap="s8">
          <F0Icon icon={GroupBy} />
          <Text.Normal whiteSpace="nowrap">Section</Text.Normal>
        </Box>
        <Box paddingLeft="s16">
          <Text size="400" weight="semibold" color="grey1000">
            {element.label}
          </Text>
          {element.description && <Text size="300">{element.description}</Text>}
        </Box>
      </Box>
      <Box gap="s32">{children}</Box>
      <Box flexDirection="row" alignItems="center">
        <div className="border-solid border-0 border-t border-f1-border-secondary w-full" />
        <Text.Normal whiteSpace="nowrap" className="text-base p-3">
          {i18n.t('forms.section_end')}
        </Text.Normal>
        <div className="border-solid border-0 border-t border-f1-border-secondary w-full" />
      </Box>
    </Box>
  )
}
